module.exports = __webpack_public_path__ + "static/media/custody.8c89bd9e.svg";